// extracted by mini-css-extract-plugin
export default {"button":"button_pNFyNac","textCollapser":"textCollapser_XryrG85"};